module.exports = __webpack_public_path__ + "static/media/gen_emg_pro.f882a24d.png";